import React, { useState } from 'react';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import ProductCardLipscoreStars from '../../Lipscore/ProductCard.LipscoreStars';
import AddSuggestedProductToCartButton from '../Utils/SuggestedProductAddToCartButton';
import SuggestProductCardPrice from '../Utils/SuggestProductCardPrice';
import SuggestedProductCardImage from '../Utils/SuggestedProductCardImage';
import { SUGGESTED_PRODUCT_SECTION } from '../../../constants';
import { SuggestedProduct } from '../../../Types/SuggestedProduct';
import { SuggestedProductCardCheckoutRow } from '../Styles/SuggestedProductCard.styling';


interface SuggestedRowProductCardProps {
  product: SuggestedProduct;
  className?: string;
}

const SuggestedProductCardCheckout = ({
  product,
  className = '',
}: SuggestedRowProductCardProps) => {

  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );
  const [email] = useState<string | any>(userInfo?.email)

  return (
    <SuggestedProductCardCheckoutRow className={`${className ?? ''}`}>
      <div className="image-wrapper">
        <SuggestedProductCardImage product={product} />
      </div>

      <div className="font-satoshi-bold text-md flex items-center justify-center">
        <a href={product.url} className="">{product.name}</a>
      </div>

      <div className='flex items-center justify-center'>
        <span className='text-sm text-gray-600 font-satoshi'>
          {product.productCardDescription}
        </span>
      </div>

      <div className="flex items-center justify-center">
        <ProductCardLipscoreStars
          productModel={product.lipscoreProduct?.productModel}
          showReviewsCount={true}
          className='hidden lg:flex'
        />
      </div>

      <div className="flex items-center justify-center">
        <SuggestProductCardPrice product={product} className='hidden lg:flex' />
      </div>

      <div className="flex items-center justify-center">
        <AddSuggestedProductToCartButton
          articleNumber={product.id}
          brandTrackingSource={product.brandTrackingSource}
          email={email}
          btnSize="small"
          className='min-w-[101px]'
          usedIn={SUGGESTED_PRODUCT_SECTION.Checkout}
        />
      </div>
    </SuggestedProductCardCheckoutRow>
  )
}

export default SuggestedProductCardCheckout